import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import RouteLoader from "./components/common/RouteLoader";

// Auth Pages
import Create from "./components/authentication/Create";
import Login from "./components/authentication/Login";
import Forgot from "./components/authentication/Forgot";
import Confirm from "./components/authentication/Confirm";
import Registrationcomplete from "./components/authentication/Registrationcomplete";

// Dashboard Layout
import DashboardCombined from "./DashboardCombined";

// Shared
import SharedLogout from "./components/shared/SharedLogout";

// Receptionist Pages
import NewCustomer from "./components/Customer-dashboard/NewCustomer";
import OrderHistory from "./components/Customer-dashboard/ReceptionistOrders/OrderHistory";
import Tailor from "./components/Customer-dashboard/Tailor";
import Track from "./components/Customer-dashboard/Track";

// Tailor Pages
import Tracktailor from "./components/Tailor-dashboard/Tracktailor";
import ViewOrder from "./components/Tailor-dashboard/ViewOrder";
import AssignedOrders from "./components/Tailor-dashboard/AssignedOrders";

// Admin Pages
import OrderInventory from "./components/Admin-dashboard/OrderInventory";
import Customers from "./components/Admin-dashboard/Customers";
import Staff from "./components/Admin-dashboard/Staff";
import TrackAdmin from "./components/Admin-dashboard/TrackAdmin";
import EditOrderForm from "./components/Customer-dashboard/ReceptionistOrders/EditOrderForm";

// 404 Page
import NotFound404 from "./components/NotFound404"; 
import EditOrderForm1 from "./components/Admin-dashboard/EditOrderForm1";

function App() {
  return (
    <ChakraProvider>
      <Router>
        <RouteLoader>
          <Routes>
            {/* Public Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/create" element={<Create />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/confirm" element={<Confirm />} />
            <Route path="/complete" element={<Registrationcomplete />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Protected Dashboard */}
            <Route path="/dashboard" element={<DashboardCombined />}>
              {/* Receptionist */}
              <Route path="new-customer" element={<NewCustomer />} />
              <Route path="order-history" element={<OrderHistory />} />
              <Route path="update-order/:orderId" element={<EditOrderForm />} />
              <Route path="update-order1/:orderId" element={<EditOrderForm1 />} />
              <Route path="master" element={<Tailor />} />
              <Route path="track" element={<Track />} />

              {/* Tailor */}
              <Route path="track-tailor" element={<Tracktailor />} />
              <Route path="order/:orderId" element={<ViewOrder />} />
              <Route path="assigned-orders" element={<AssignedOrders />} />

              {/* Admin */}
              <Route path="order" element={<OrderInventory />} />
              <Route path="customers" element={<Customers />} />
              <Route path="staff" element={<Staff />} />
              <Route path="trackadmin" element={<TrackAdmin />} />

              {/* Logout */}
              <Route path="logout" element={<SharedLogout />} />
            </Route>

            {/* 404 - Catch All Unmatched Routes */}
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </RouteLoader>
      </Router>
    </ChakraProvider>
  );
}

export default App;
